import { Injectable } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { CdsSubscription, GridSubscription } from '@frontend/sports/content-distribution/feature';
import { MessageCallback } from '@frontend/sports/event-subscription/feature/base-subscription';
import { EventSubscriptionService } from '@frontend/sports/event-subscription/feature/event-subscription';

/**
 * This service should be used for subscribing grid event for push. It automatically
 * subscribes to scoreboard slim and all grid configured markets including V1 and V2
 * games and option markets
 *
 * @export
 * @class GridSubscriptionService
 * @extends {BaseSubscriptionService}
 */
@Injectable({ providedIn: 'root' })
export class GridSubscriptionService extends EventSubscriptionService {
    protected override getContextSubscriptions(event: EventModel, callback: MessageCallback): CdsSubscription[] {
        return [new GridSubscription(event.offerContext, event.id, this.connection.culture, callback)];
    }
}
